import { render, staticRenderFns } from "./HandleSlideImg.vue?vue&type=template&id=261ba5b0&scoped=true"
import script from "./HandleSlideImg.vue?vue&type=script&lang=js"
export * from "./HandleSlideImg.vue?vue&type=script&lang=js"
import style0 from "./HandleSlideImg.vue?vue&type=style&index=0&id=261ba5b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261ba5b0",
  null
  
)

export default component.exports